import { computed } from 'vue'
import { translate } from 'src/layouts/core-layout/_functions/translate'
import type { SideMenuProjects } from 'src/layouts/core-layout/components/CoreHeader/components/mobile/TheHeader/TheHeader.types'
import type useTheHeaderSite from 'src/layouts/core-layout/components/CoreHeader/components/mobile/TheHeader/composables/useTheHeaderSite'

type HeaderSite = ReturnType<typeof useTheHeaderSite>

export default function useTheHeaderProjects(site: HeaderSite) {
  const {
    context,
    isProdoctorov,
    isProbolezny,
    isProtabletky,
  } = site

  const projects = computed<SideMenuProjects | undefined>(() => {
    const staticSrc = String(context.global?.static?.src || '/static/')
    const { siteNameML, siteNameMF, siteNameMT } = context.global.sites
    const sites = context.global?.sites || {}
    const allProjects: SideMenuProjects = {
      medtochka: {
        logo: `${staticSrc}_v1/pd/logos/ui-kit/medtochka-logo.svg`,
        description: translate('Личный кабинет пациента и медкарта'),
        url: siteNameMT,
      },
      medflex: {
        logo: `${staticSrc}_v1/pd/logos/ui-kit/medflex-logo.svg`,
        description: translate('Сервис безопасного обмена медицинскими данными'),
        url: siteNameMF,
      },
      medlock: {
        logo: `${staticSrc}_v1/pd/logos/ui-kit/medlock-logo.svg`,
        description: translate('Медицинская информационная система'),
        url: siteNameML,
      },
    }

    if (!isProdoctorov.value) {
      allProjects.prodoctorov = {
        logo: `${staticSrc}_v1/pd/logos/ui-kit/prodoctorov-logo.svg`,
        description: translate('Сайт отзывов о врачах №1 в России'),
        url: String(sites.siteNamePD || 'https://prodoctorov.ru/'),
      }
    }

    if (!isProtabletky.value) {
      allProjects.protabletky = {
        logo: `${staticSrc}_v1/pd/logos/ui-kit/protabletky-logo.svg`,
        description: translate('Сайт отзывов врачей о лекарствах'),
        url: String(sites.siteNamePT || 'https://protabletky.ru/'),
      }
    }

    if (!isProbolezny.value) {
      allProjects.probolezny = {
        logo: `${staticSrc}_v1/pd/logos/ui-kit/probolezny-logo.svg`,
        description: translate('Научно-популярная энциклопедия заболеваний'),
        url: String(sites.siteNameBL || 'https://probolezny.ru/'),
      }
    }

    return Object.keys(allProjects).length ? allProjects : undefined
  })

  return {
    projects,
  }
}
